import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { getShowAllFavouritesLink } from 'apps/catalogue/links';
import FopRibbon from 'apps/fops/components/FopRibbon';
import SectionType from 'apps/catalogue/models/SectionType';

export default class ShowAllFavourites extends PureComponent {
  static propTypes = {
    pageParameters: PropTypes.object.isRequired,
  };

  render() {
    return (
      <li className="fops-item fops-item--showAllFavourites">
        <FopRibbon sectionType={SectionType.FAVOURITES} idx={-1} />
        <Link
          to={getShowAllFavouritesLink(this.props.pageParameters)}
          className="fop-showAllFavourites"
        >
          <div className="fop-showAllFavourites__btn" />
          <div className="fop-showAllFavourites__description">Show all favourites</div>
        </Link>
      </li>
    );
  }
}
